import type {ActionReducerMapBuilder} from '@reduxjs/toolkit';
import type {EventPromotionReducerState} from '@Components/mystuff-event-promotion-page/mystuff-event-promotion-page.types';
import {deletePrintFlyerPoster, deleteSocialPostFromEvent, getEventPromotionInfo, markOneClickBannerAsSeen, markPromotionStepAsCompleted, markPromotionStepAsSkipped} from '@Components/mystuff-event-promotion-page/mystuff-event-promotion-page-thunk';
import {LoadingStates} from '@Utils/loading.util';
import {getPromotionStepFromType} from "@Libraries/event-promotion.library";

export const mystuffEventPromotionPageExtraReducers = (builder: ActionReducerMapBuilder<NoInfer<EventPromotionReducerState>>): void => {
  builder.addCase(getEventPromotionInfo.pending, (state) => {
    state.loadingState = LoadingStates.LOADING;
  });

  builder.addCase(getEventPromotionInfo.fulfilled, (state, {payload}) => {
    state.event = payload.event;
    state.loadingState = LoadingStates.LOADED;
    state.stats = {
      reach: payload.stats.reach,
      views: payload.stats.views,
      registrations: payload.stats.registrations,
    };
    state.promotionSteps = payload.promotionSteps;
    state.socialPosts = payload.socialPosts;
    state.emailCampaigns = payload.emailCampaigns;
    state.printFlyers = payload.printFlyers;
    state.showOneClickPromotionBanner = payload.showOneClickPromotionBanner;
    state.areEventPreviewsReady = payload.areEventPreviewsReady;
  });

    builder.addCase(markPromotionStepAsCompleted.pending, (state, {meta}): void  => {
        const step = getPromotionStepFromType(state.promotionSteps, meta.arg.promotionType);

        if (step) {
            step.isCompleted = true;
            step.isSkipped = false;
        }
    });

    builder.addCase(markPromotionStepAsSkipped.pending, (state, {meta}): void  => {
        const step = getPromotionStepFromType(state.promotionSteps, meta.arg.promotionType);

        if (step) {
            step.isCompleted = false;
            step.isSkipped = true;
        }
    });

    builder.addCase(deletePrintFlyerPoster.pending, (state, {meta}): void  => {
        state.printFlyers = state.printFlyers.filter(flyer => {
            return flyer.posterHashedID !== meta.arg.posterHashedId;
        });
    });

    builder.addCase(deleteSocialPostFromEvent.pending, (state, {meta}): void => {
        state.socialPosts = state.socialPosts.filter(post => {
            return post.id !== meta.arg.socialPostId;
        });
    });

    builder.addCase(markOneClickBannerAsSeen.pending, (state) => {
        state.showOneClickPromotionBanner = false;
    })
};